if (!customElements.get('video-play')) {
  class VideoPlay extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(
        new CustomEvent('video-player:toggle', {
          detail: { id: this.getAttribute('data-target-id') },
        }),
      );
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('video-play', VideoPlay);
}
